import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getListLeaveRequest: ["children_id", "page"],
  getListLeaveSuccess: ["listLeave"],
  getListLeaveFailure: null,
});

export const GetListLeaveTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  payload: null,
  success: null,
  error: null,
  children_id: null,
  page: null,
});

export const GetListLeaveSelectors = {
  getData: (state: any) => state.getListLeave.data,
  isFetching: (state: any) => state.getListLeave.fetching,
  isSuccess: (state: any) => state.getListLeave.success,
  hasError: (state: any) => state.getListLeave.error,
};

export const request = (state: any, { children_id, page }: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    children_id,
    payload: null,
    page,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { listLeave } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    listLeave,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_LIST_LEAVE_REQUEST]: request,
  [Types.GET_LIST_LEAVE_SUCCESS]: success,
  [Types.GET_LIST_LEAVE_FAILURE]: failure,
});
